import React from "react";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { sectionHint } from "../../models/access-tree";
import styles from "./AccessEditor.module.scss";

/** Название раздела прав; если у его прав есть пояснение — значок «?» и подсказка при наведении */
export const SectionName = ({ name, items }: SectionNameProps) => {
    const hint = sectionHint(items);

    if (!hint) {
        return <>{name}</>;
    }

    return (
        <span className={styles.hinted} title={hint}>
            {name}
            <GeneralIcon type="general-question" size={14} className={styles.hintIcon} />
        </span>
    );
};

interface SectionNameProps {
    name: string;
    items: { code: string }[];
}
